import type { TError, TLessonBase } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';

/**
 * Query key for fetching lessons in a space - non-hook version
 */
export const getLessonsQueryKey = (spaceId: string) => [ENTITY, 'lessons', spaceId];

/**
 * Query key for fetching lessons in a space
 */
export const useGetLessonsQueryKey = (spaceId: string) => getLessonsQueryKey(spaceId);

interface UseGetLessonsOptions {
  enabled?: boolean;
}

/**
 * Hook to fetch all lessons in a content sub-space
 * Returns published lessons ordered by position
 *
 * @param spaceId - Space ID (UUID) - should be a content sub-space
 * @param options - Query options (enabled, etc.)
 */
export const useGetLessons = (spaceId: string, options?: UseGetLessonsOptions) => {
  const enabled = options?.enabled ?? true;

  return useQuery<TLessonBase[], TError>({
    queryKey: useGetLessonsQueryKey(spaceId),
    queryFn: async () => {
      const res = await axios.get<TLessonBase[]>(`/community-hub/spaces/${spaceId}/lessons`);
      return res.data;
    },
    enabled: !!spaceId && enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
